import React, { memo } from 'react';
import Input from '../../styled/Input';
import { camelize } from '../../utils';
import { FormInputLabel } from './EditorForm.styles';

interface FormSchemaInputProps {
  label: string;
  id: string;
  onChange: (e: any) => void;
  value: string;
  as?: any;
}

const FormSchemaInput: React.FC<FormSchemaInputProps> = ({
  label,
  onChange,
  value,
  as,
  id,
}) => {
  return (
    <div>
      <FormInputLabel htmlFor={camelize(label)}>
        <span>{label}</span>
        <Input
          placeholder={label}
          onChange={onChange}
          value={value || ''}
          name={camelize(id)}
          as={as}
        />
      </FormInputLabel>
    </div>
  );
};

export default memo(FormSchemaInput);
